import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main_div" }

import { ref, onMounted } from "vue"; // 필요한 경우 주석 해제
import {
    // NDataTable, // 현재 템플릿에서 사용되지 않음
    NSpace,
    NCard,
    // NSelect, // 현재 템플릿에서 사용되지 않음
    // NDatePicker, // 현재 템플릿에서 사용되지 않음
    // NButton, // 현재 템플릿에서 사용되지 않음
    // NModal, // 현재 템플릿에서 사용되지 않음
} from "naive-ui";
// import { getCallable } from "@/config/env"; // 현재 사용되지 않음
// import * as common from "@/assets/common/common"; // 현재 사용되지 않음
// import * as constant from "@/assets/constant"; // 현재 사용되지 않음

export default /*@__PURE__*/_defineComponent({
  __name: 'Statistics',
  setup(__props) {

const componentKey = ref(0); // To force re-render if needed
// onMounted(async () => {
//   // mounted 로직이 필요하다면 여기에 작성
// });

// data 속성이 필요하다면 ref 또는 reactive를 사용하여 선언
// 예: const myData = ref(null);

// methods가 필요하다면 일반 함수로 정의
// 예: function myMethod() { /* ... */ }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("div", {
      style: {"height":"auto"},
      key: componentKey.value
    }, [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "통계 관리", -1)
                ])),
                _: 1
              }),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _cache[2] || (_cache[2] = _createElementVNode("div", null, [
                _createElementVNode("p", null, "aaa")
              ], -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})